<template>
  <div class="layout-page">
    <top id="top-nav" :title="bookTitle" :key="`${bookInfo.bookId}-home`"></top>
    <div class="aui-footer aui-footer-fixed book-foot" style="padding:0">
      <div class="put-shelf active" @click="addShelfNovel">
        <img src="../../../assets/img/shelf-a-ico.png" />
        <span>{{addedToShelf ? '移除书架' : '加入书架'}}</span>
      </div>
      <div class="read" @click="toReadHandler('history')" v-if="history">
        <span>开始阅读</span>
      </div>
      <div class="read" @click="toReadHandler()" v-else>
        <span>开始阅读</span>
      </div>
    </div>
    <div :id="`scroll-div-book-home-${this.$route.params.id}`" class="aui-scrollView">
      <div class="detail-mask" :style="getCoverStyle()"></div>
      <div class="book-detail">
        <div class="cover">
          <img imgtype="novel" :bookid="bookInfo.bookId" :booktitle="bookInfo.title" :chapternum="0" :imgpath="bookInfo.cover" :zoom="2000"  v-lazy="require('../../../assets/images/loading.jpeg')"/>
        </div>
        <div class="title">
          <h3>{{bookInfo.title}}</h3>
          <span>{{bookInfo.categoryName}}</span>
          <span class="ml15">类型：{{bookInfo.categoryName}}</span>
          <div class="aui-flex-box">
            <span class="i-b" v-if="bookInfo.publishStatus === 'serialize'">连载中</span>
            <span class="i-a" v-else>已完结</span>
          </div>
        </div>
      </div>
      <div class="intro" :class="{'auto': showIntro}">
        <span class="content">{{getContent}}</span>
      </div>
      <div
        class="more"
        v-if="bookInfo.abstractContent &&bookInfo.abstractContent.length > 75"
        :class="{'up': showIntro}"
        @click="showIntro = !showIntro"
      >
        <img src="../../../assets/img/down.png" />
      </div>
      <div class="menu" @click="toCatalog">
        <a>
          目录
          <span>共{{bookInfo.chapterCount}}章</span>
        </a>
      </div>
      <a class="history-r" @click="toReadHandler('history')" v-if="history">
        <span class="bg-red">上次阅读</span>
        <span>{{history.title}}</span>
        <span class="c-red">继续阅读</span>
      </a>
      <a class="history-r" @click="toReadHandler('last')">
        <span class="bg-red">最新</span>
        <span>{{lastChapter.title}}</span>
      </a>
      <div class="divHeight"></div>

      <div class="novel-b-normal">
        <books-normal :title="'看过本书的还爱看'" :books="recommends" :show-more="false"></books-normal>
      </div>
      

    </div>
  </div>
</template>

<script>
import BooksNormal from '@/components/share/books-normal'
import BookTop from '@/components/layer2/book/book-top'
import novelService from '../../../services/novelService'
import shelfService from '../../../services/shelfService'
import { getImg } from '../../../services/urlService'
import userService from '../../../services/userService'

export default {
  name: 'novel-home',
  data () {
    return {
      componentName: '',
      bookInfo: {},
      chapters: [],
      lastChapter: {},
      recommends: [],
      addedToShelf: false,
      history: undefined,
      bookTitle: '',
      showIntro: false
    }
  },
  computed: {
    getContent () {
      const abstractContent = this.bookInfo.abstractContent || ''
      if (abstractContent.length > 75 && !this.showIntro) {
        return abstractContent.substr(0, 75) + '....'
      }
      return abstractContent
    }
  },
  methods: {
    toCatalog () {
      this.$router.isBack = false
      this.$router.push({
        path: `${this.$route.path}/catalog`,
        query: { title: this.bookInfo.title }
      })
    },
    getBookDetail () {
      
      novelService
        .getDetail(this.$route.params.id)
        .then(res => {
          console.log(res.data)
          const data = res.data
          this.bookInfo = data.novelBook
          this.chapters = data.chapterList
          this.lastChapter = data.lastChapter
          this.recommends = data.recommendList
          this.bookTitle = data.book.title
          this.isAddedToShelf()
        })
        .catch(() => {
          this.$dialog.confirm({
            message: '网络超时，请刷新重试'
          }).then(() => {
            this.getBookDetail()
          })
        })
    },
    getCoverStyle () {
      const url = this.getCover()
      return `background-image: url(${url})`
    },
    getCover () {
      if (this.bookInfo.horiCover) {
        return getImg(this.bookInfo.horiCover)
      }
    },
    getPriceText (price) {
      if (price === 0 || price === '0') {
        return '免费'
      } else {
        return `${price}阅币`
      }
    },
    addShelfNovel () {
      this.addedToShelf = shelfService.addShelfNovel(this.bookInfo)
    },
    isAddedToShelf () {
      const shelfBook = shelfService.getShelfNovel().find(item => {
        return item.title === this.bookInfo.title
      })
      this.addedToShelf = !!shelfBook
    },
    toReadHandler (type) {
      if (type === 'history') {
        this.toRead(this.history ? this.history.number : 1)
      } else if (type === 'last') {
        this.toRead(this.lastChapter.number)
      } else {
        this.toRead(1)
      }
    },
    toRead (number) {
      number = parseInt(number)
      this.$router.isBack = false
      const book = this.chapters.find(item => item.number === number)
      const title2 = book || ''
      this.$router.push({
        path: `/novels/read/${this.bookInfo.bookId}/${number}`,
        query: {
          title: this.bookInfo.title,
          title2: title2
        }
      })
      shelfService.addHistory(this.bookInfo, number)
    },
    getHistory (bookId) {
      this.history = shelfService.getHistoryById(parseInt(bookId))
    }
    // hideModal () {
    //   const obj = document.getElementById('show-history-modal')
    //   obj.style.opacity = 1
    //   this.fadeOut(obj)
    // },
    // fadeOut (obj) {
    //   obj.style.opacity -= 0.05
    //   if (obj.style.opacity > 0) {
    //     setTimeout(() => {
    //       this.fadeOut(obj)
    //     }, 15)
    //   } else {
    //     this.showModal = false
    //   }
    // }
  },
  components: {
    'books-normal': BooksNormal,
    top: BookTop
  },
  mounted () {
    userService.register();
    this.componentName = this.$route.path
    if (
      this.$store.state.pageState[this.componentName] &&
      this.$router.isBack
    ) {
      Object.assign(
        this.$data,
        this.$store.state.pageState[this.componentName].data
      )
      setTimeout((vue = this) => {
        const scrollDiv = document.getElementById(
          `scroll-div-book-home-${this.$route.params.id}`
        )
        scrollDiv.scrollTop = vue.$store.state.pageState[vue.componentName].top
      }, 5)
    } else {
      this.getBookDetail()
    }
    this.$router.isBack = true
    this.getHistory(this.$route.params.id)
  },
  beforeDestroy () {
    this.$dialog.close()

    const scrollDiv = document.getElementById(
      `scroll-div-book-home-${this.bookInfo.bookId}`
    )
    const state = {}
    state[this.componentName] = { data: this.$data, top: scrollDiv.scrollTop }
    this.$store.commit('saveState', state)
  }
}
</script>


<style scoped>

@import "../../../assets/css/novel.css";

</style>





// WEBPACK FOOTER //
// src/pages/layer2/novels/home.vue